export const QUOTATION_STATES = {
	OPEN:1,
	APPROVED:2,
	DELETED:3,
	AUTHORIZATION_REQUEST:4,
}